import { useMemo, useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { Code } from '@factorialco/f0-react/icons/app'
import { motion } from 'framer-motion'
import { format } from 'sql-formatter'

import i18n from 'modules/core/lib/i18n'

export const ViewQuery = ({ query }: { query: string }) => {
  const [visible, setVisible] = useState(false)

  const formattedQuery = useMemo(() => {
    return format(query)
  }, [query])

  return (
    <Box alignItems="flexStart" flexDirection="row" gap="s16">
      <Box minWidth="s120">
        <F0Button
          icon={Code}
          label={
            visible
              ? i18n.t('ai_reports.reports.hide_query')
              : i18n.t('ai_reports.reports.view_query')
          }
          size="sm"
          variant="outline"
          onClick={() => setVisible(!visible)}
        />
      </Box>

      <motion.div
        className="overflow-hidden relative"
        style={{
          height: !visible ? 0 : 'auto',
        }}
        animate={{ height: !visible ? 0 : 'auto' }}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
      >
        <Box
          padding="s16"
          className="monospace"
          maxWidth="s600"
          maxHeight="s300"
          overflowY="auto"
          background="white"
          borderRadius={{ all: 'abs008' }}
        >
          <Text.Normal size="100">
            <pre>{formattedQuery}</pre>
          </Text.Normal>
        </Box>
      </motion.div>
    </Box>
  )
}
